module.exports = __webpack_public_path__ + "static/image/company/pc/image_value.jpg?7b341032";